module.exports = __webpack_public_path__ + "static/media/ic_text_selected.93a9ad9c.svg";